if (!customElements.get('caramel-toffee-builder')) {
  customElements.define('caramel-toffee-builder', class extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.variantSelect = this.form?.querySelector('[data-ctb-variant-select]');
      this.variants = JSON.parse(this.querySelector('[data-ctb-variants]')?.textContent || '[]');
      this.cavities = [...this.querySelectorAll('[data-ctb-cavity]')];
      this.dialog = this.querySelector('[data-ctb-dialog]');
      this.activeSlot = null;
      this.complete = false;
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: 'USD' });

      this.cavities.forEach((cavity) => {
        cavity.querySelector('[data-cavity-type]').addEventListener('change', (event) => {
          this.clearCavity(cavity);
          cavity.dataset.type = event.target.value;
          this.update();
        });
        cavity.querySelectorAll('[data-flavor-slot]').forEach((slot) => slot.addEventListener('click', () => this.openPicker(cavity, slot)));
      });
      this.querySelectorAll('[data-flavor-choice]').forEach((choice) => choice.addEventListener('click', () => this.chooseFlavor(choice)));
      this.querySelector('[data-dialog-close]')?.addEventListener('click', () => this.dialog.close());
      this.dialog?.addEventListener('click', (event) => { if (event.target === this.dialog) this.dialog.close(); });
      this.form?.addEventListener('submit', (event) => {
        if (this.complete) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        window.alert('Please choose the rest of your flavors before adding to cart.');
      }, true);
      document.addEventListener('zm:item-added', (event) => {
        if (event.detail?.form === this.form) window.alert('Caramel & Toffee Box has been added to cart.');
      });
      this.update();
    }

    clearCavity(cavity) {
      cavity.querySelectorAll('[data-flavor-slot]').forEach((slot) => {
        delete slot.dataset.flavorName;
        delete slot.dataset.flavorImage;
        slot.querySelector('[data-slot-name]').textContent = 'Choose a flavor';
        slot.querySelector('[data-slot-image]').innerHTML = slot.dataset.piece;
      });
    }

    openPicker(cavity, slot) {
      const type = cavity.querySelector('[data-cavity-type]').value;
      if (!type) {
        cavity.querySelector('[data-cavity-type]').focus();
        this.querySelector('[data-ctb-summary]').textContent = 'Choose Caramel or Toffee Bar for this section first.';
        return;
      }
      this.activeSlot = slot;
      const visible = [...this.querySelectorAll('[data-flavor-choice]')].filter((choice) => {
        choice.hidden = choice.dataset.flavorType !== type;
        return !choice.hidden;
      });
      this.querySelector('[data-dialog-title]').textContent = `Choose a ${type === 'toffee' ? 'Toffee Bar' : 'Caramel'} flavor`;
      this.querySelector('[data-flavor-empty]').hidden = visible.length > 0;
      this.dialog.showModal();
      visible[0]?.focus();
    }

    chooseFlavor(choice) {
      if (!this.activeSlot) return;
      this.activeSlot.dataset.flavorName = choice.dataset.flavorName;
      this.activeSlot.dataset.flavorImage = choice.dataset.flavorImage || '';
      this.activeSlot.querySelector('[data-slot-name]').textContent = choice.dataset.flavorName;
      const image = this.activeSlot.querySelector('[data-slot-image]');
      image.replaceChildren();
      if (choice.dataset.flavorImage) {
        const thumbnail = document.createElement('img');
        thumbnail.src = choice.dataset.flavorImage;
        thumbnail.alt = choice.dataset.flavorAlt || choice.dataset.flavorName;
        image.append(thumbnail);
      } else {
        image.textContent = this.activeSlot.dataset.piece;
      }
      this.dialog.close();
      this.update();
    }

    variantFor(toffeePieces) {
      return this.variants.find((variant) => {
        const title = variant.title.toLowerCase();
        if (toffeePieces === 0) return title.includes('8 caramels');
        if (toffeePieces === 8) return title.includes('8 toffee');
        return title.includes(`${toffeePieces} toffee`);
      });
    }

    update() {
      const types = this.cavities.map((cavity) => cavity.querySelector('[data-cavity-type]').value);
      const toffeePieces = types.filter((type) => type === 'toffee').length * 2;
      const caramelPieces = 8 - toffeePieces;
      const variant = this.variantFor(toffeePieces);
      const completedSlots = this.cavities.reduce((total, cavity) => total + [...cavity.querySelectorAll('[data-flavor-slot]')].filter((slot) => slot.dataset.flavorName).length, 0);
      const typesComplete = types.every(Boolean);
      const complete = typesComplete && completedSlots === 8;
      this.complete = complete;

      this.cavities.forEach((cavity, index) => {
        const type = types[index];
        const names = [...cavity.querySelectorAll('[data-flavor-slot]')].map((slot) => slot.dataset.flavorName).filter(Boolean);
        cavity.querySelector('[data-cavity-property]').value = type && names.length === 2 ? `${type === 'toffee' ? 'Toffee Bar' : 'Caramel'} — ${names.join(' + ')}` : '';
        cavity.classList.toggle('is-complete', Boolean(type && names.length === 2));
      });

      const mix = toffeePieces === 0 ? '8 Caramels' : toffeePieces === 8 ? '8 Toffee Bars' : `${caramelPieces} Caramels + ${toffeePieces} Toffee Bars`;
      this.querySelector('[data-ctb-mix]').value = typesComplete ? mix : '';
      if (variant && this.variantSelect) {
        this.variantSelect.value = String(variant.id);
        this.variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
        const price = this.money.format(variant.price / 100);
        document.querySelectorAll('[data-product-price], .product-sticky-cart__details span').forEach((node) => { node.textContent = price; });
      }

      const submit = this.form?.querySelector('.product-form__submit');
      const purchasable = Boolean(complete && variant?.available);
      if (submit) {
        submit.disabled = complete && !purchasable;
        submit.textContent = !complete ? 'Complete your box' : variant?.available ? 'Add configured box' : 'Selected mix is sold out';
      }
      const remaining = 8 - completedSlots;
      this.querySelector('[data-ctb-summary]').textContent = !typesComplete
        ? 'Choose Caramel or Toffee Bar for all four sections.'
        : !complete
          ? `${mix} selected. Choose ${remaining} more ${remaining === 1 ? 'flavor' : 'flavors'}.`
          : variant?.available
            ? `${mix} — ${this.money.format(variant.price / 100)}. Your box is ready to add.`
            : `${mix} is configured, but this pricing variant is currently sold out.`;
      this.classList.toggle('is-complete', complete);
    }
  });
}
